import gsap from 'gsap';
import './Intro.scss';
import { useEffect, useLayoutEffect, useRef } from 'react';
import useGsapContext from 'src/app/hooks/UseGsapContext';
import { selectScene } from 'src/app/redux/slice/sceneSlice';
import { useDispatch } from 'react-redux';

const scenesImages = require.context('../../../../assets/scenes');
const logos = require.context('../../../../assets/logos');

const IntroMobile = ({ data, allowScroll }) => {
  const dispatch = useDispatch();

  const containerRef = useRef();
  const introRef = useRef();
  const titleRef = useRef();
  const collageRef = useRef();
  const textboxRef = useRef();
  const logoDesktopRef = useRef();
  const logoMobileRef = useRef();

  const nextScene = (id) => {
    console.log('NEXT');
    gsap.to(introRef.current, { opacity: 0 });
    gsap.to(logoDesktopRef.current, { opacity: 0 });
    gsap.to(logoMobileRef.current, { opacity: 0 });
    setTimeout(() => {
      dispatch(selectScene(id));
    }, 500);
  };

  const ctx = useGsapContext(containerRef);

  useEffect(() => {
    allowScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    ctx.add(() => {
      gsap.set(introRef.current, { opacity: 0 });
      gsap.set(logoDesktopRef.current, { opacity: 0 });
      gsap.set(logoMobileRef.current, { opacity: 0 });
      gsap.to(introRef.current, {
        opacity: 1,
        keyframes: { y: [100, 0] },
      });
      gsap.to(logoMobileRef.current, {
        opacity: 1,
      });
      gsap.to(logoDesktopRef.current, {
        opacity: 1,
        keyframes: { y: [100, 0] },
      });
    });
    return () => ctx.revert();
  });

  return (
    <div
      className="container"
      style={{ position: 'relative' }}
      ref={containerRef}
    >
      <div className="intro" ref={introRef}>
        <div className="intro-logo-mobile" ref={logoMobileRef}>
          <a href={data?.logo?.dir}>
            <img
              width="321px"
              height={'auto'}
              data-depth={'0.18'}
              src={logos(data?.logo?.url)}
              alt={data?.logo?.alt}
            />
          </a>
        </div>
        <div className="intro-title" ref={titleRef}>
          <h2>{data?.title}</h2>
        </div>
        <div className="intro-collage" ref={collageRef}>
          <div className="intro-collage-parallax">
            <img
              aria-hidden="true"
              className="img1 parallax"
              data-depth={'0.20'}
              src={scenesImages(data?.collage?.img1?.url)}
              alt=""
              width="321px"
            />
            <img
              className="img2 parallax"
              width="321px"
              height={'auto'}
              data-depth={'0.18'}
              src={scenesImages(data?.collage?.img2?.url)}
              alt="Collage: precursores de CIAT realizando una planacion para el desarrollo de la empresa"
            />
            <img
              aria-hidden="true"
              className="img3 parallax"
              data-depth={'0.17'}
              src={scenesImages(data?.collage?.img3?.url)}
              width="321px"
              alt=""
            />
          </div>
        </div>
        <div className="intro-textbox" ref={textboxRef}>
          <h3>{data?.subtitle}</h3>
          <div
            className="intro-textbox-format"
            dangerouslySetInnerHTML={{ __html: data?.description }}
          ></div>
        </div>
      </div>
      <div className="scroll-controls">
        <button onClick={() => nextScene('02')} aria-label="Next">
          <div className="scroll-next"></div>
        </button>
      </div>
    </div>
  );
};

export default IntroMobile;
